import React from 'react';
import { Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();

  return (
    <Button
      variant="outlined"
      color="error"
      onClick={logout}
      sx={{
        borderRadius: '0.75rem',
        textTransform: 'none',
        px: 3,
        py: 1,
        fontWeight: 600,
        fontSize: '1rem',
        '&:hover': {
          bgcolor: '#fee2e2',
          borderColor: '#dc2626',
          color: '#b91c1c',
          transition: 'all 0.3s ease',
        },
      }}
    >
      Sair
    </Button>
  );
};

export default Logout;
